import { OrderItem } from '@morning-dashboard/context/MorningDashboardContextProps';

export const sortWidgetByOrder = (array: OrderItem[]) => {
  if (!Array.isArray(array)) throw new Error('Expected an array of OrderItem objects');
  if (!array) return [];
  return array.sort((a, b) => a.order - b.order);
};
